import React from 'react';

import styled from 'styled-components';

const NotFoundPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }
`;

const NotFoundPage = () => {
  return (
    <NotFoundPageWrapper>
      <h1>Página não encontrada.</h1>
      <h2>A página que você está tentando acessar pode ter sido removida, ter trocado de endereço<br />ou está temporariamente indisponível. <br />Tente novamente mais tarde.</h2>
    </NotFoundPageWrapper>
  );
};

export default NotFoundPage;
